var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.usersSearchEnabled(_vm.permissionIsEnabled)
        ? _c("dash-filter", {
            attrs: {
              options: _vm.filterOptions,
              default: _vm.queryString,
              loadingList: _vm.loadingList,
              action: _vm.action,
            },
            model: {
              value: _vm.queryString,
              callback: function ($$v) {
                _vm.queryString = $$v
              },
              expression: "queryString",
            },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "el-section" },
        [
          _c(
            "emd-card",
            {
              staticClass: "_highlight_header _header_spaced _footer_spaced_sm",
              attrs: { noBorder: "" },
            },
            [
              _c(
                "emd-card-header",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "actions",
                      fn: function () {
                        return [
                          _vm.permissionIsEnabled("account_staff.invite:create")
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "jsModalOpen",
                                  attrs: { to: { name: "invites-create" } },
                                },
                                [
                                  _c(
                                    "jade-button",
                                    {
                                      attrs: {
                                        variant: "primary-solid",
                                        size: "small",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("users.invite")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("emd-text", { attrs: { size: "section", tag: "h2" } }, [
                    _vm._v(_vm._s(_vm.$t("users.title")) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "emd-card-content",
                { attrs: { customClass: "eu-no-padding" } },
                [
                  _vm.loadingList
                    ? _c(
                        "div",
                        { staticClass: "eu-pa_6 eu-align_center" },
                        [_c("emd-loader", { attrs: { type: "_invert" } })],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "emd-table-responsive" },
                        [
                          _c("Table", {
                            attrs: {
                              fields: _vm.fields,
                              items: _vm.users.items,
                              toDetail:
                                _vm.usersGetEnabled(_vm.permissionIsEnabled) &&
                                _vm.toDetail,
                            },
                          }),
                          _vm.showEmptyList
                            ? _c("empty-list", { attrs: { entity: "users" } })
                            : _vm._e(),
                        ],
                        1
                      ),
                  !_vm.loadingList
                    ? _c("pagination", {
                        attrs: {
                          pagination: _vm.users.pagination,
                          totalShowing: _vm.totalItems,
                          type: "list",
                          action: _vm.action,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }